import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import Button from "../../../../../lib/html5-software-library/src/ranj/components/buttons/Button";
import Anchor from "../../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../core/application/MediatorManager";
import SoundStreamingChannels from "../../../core/sound/util/SoundStreamingChannels";
import SystemMessageBuilder from "../../../core/system-message/controller/SystemMessageBuilder";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import PullContentManager from "../../pull/PullContentManager";
import ScenarioPlayerEvent from "../../scenario/ScenarioPlayerEvent";

export default class WorkspaceScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {MediatorManager} mediatorManager 
     * @param {PullContentManager} pullContentManager 
     * @param {SoundManager} soundManager 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, mediatorManager, pullContentManager, soundManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._mediatorManager = mediatorManager;
        this._pullContentManager = pullContentManager;

        this._soundManager = soundManager;
    }

    initialize() {
        super.initialize();

        this._introMessageTimeout = setTimeout(() => {
            const systemMessage = new SystemMessageBuilder()
                .setTitle('Welcome to your workspace')
                .setDescription(`From here you can access your smartphone, laptop or start a dummy dialog.`)
                .addOption({ text: 'OK' })
                .build();
            this.showSystemMessage(systemMessage);

            this._introMessageTimeout = null;
        }, 650);

        this.createButton(this._target.startDialogButton, this._handleStartDialogButton.bind(this), 'Start dialog');
        /** @type {Button} */
        this._playVoiceOverButton = this.createButton(this._target.playVoiceOverButton, this._handlePlayVoiceOverButton.bind(this), 'Play audio');

        if (this._target.openLaptopButton) {
            if (SkinKeyRegistry.LAPTOP_OPENER_MEDIATOR) {
                this.anchorObject(this._target.openLaptopButton, Anchor.B);
                this._laptopMediator = this._mediatorManager.createMediator(this._target.openLaptopButton, SkinKeyRegistry.LAPTOP_OPENER_MEDIATOR);
            } else {
                this._target.openLaptopButton.visible = false;
            }
        }

        if (this._target.openSmartphoneButton) {
            if (SkinKeyRegistry.SMARTPHONE_OPENER) {
                this.anchorObject(this._target.openSmartphoneButton, Anchor.B);
                this._laptopMediator = this._mediatorManager.createMediator(this._target.openSmartphoneButton, SkinKeyRegistry.SMARTPHONE_OPENER);
            } else {
                this._target.openSmartphoneButton.visible = false;
            }
        }

        this.stretchBackground();
        this.preventClickThrough();
    }

    destroy() {
        super.destroy();

        if (this._introMessageTimeout) {
            clearTimeout(this._introMessageTimeout);
            this._introMessageTimeout = null;
        }

        if (this._laptopMediator) {
            this._laptopMediator.destroy();
        }
        if (this._smartphoneOpenerMediator) {
            this._smartphoneOpenerMediator.destroy();
        }
    }

    _handleStartDialogButton() {
        const dialogContent = this._pullContentManager.pullContent[0];
        const dialogContentPlayer = this._pullContentManager.getContentPlayerForContent(dialogContent);

        const commandEvent = new ScenarioPlayerEvent(ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE, dialogContent, dialogContentPlayer);
        this.dispatch(commandEvent.type, { data: commandEvent });

        this.closeScreen(this._target);
    }

    _handlePlayVoiceOverButton() {
        this._playVoiceOverButton.setEnabled(false);

        const onStreamCompleted = () => {
            this._playVoiceOverButton.setEnabled(true);
        };

        const soundUrl = 'assets/sounds/subtitle-sample/SubtitleSample.ogg';
        const subtitleUrl = 'assets/sounds/subtitle-sample/SubtitleSample.vtt';
        this._soundManager.streamSound(soundUrl, onStreamCompleted, onStreamCompleted, null, SoundStreamingChannels.VOICE_OVER, null, null, subtitleUrl);
    }
}